export default __webpack_public_path__ + "static/media/vaishnavi.afc5b958.png";